(function () {
  'use strict';

  angular
    .module('vcdms.vcdoctype')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcdmsdoctype', {
        url: '/vcdmsdoctype',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;doctypesearch doctype="" doctyperef="" editinplace="true"&gt;</tt></h3><div ui-view="doctypesearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;doctypesearch doctype="" doctyperef="" parentsave=""&gt;</tt></h3><div ui-view="doctypesearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;doctypeeditor doctype="" mode="" onClose=""&gt;</tt></h3><div ui-view="doctypeeditview"></div>
              <h3 class="alert alert-info"><tt>&lt;doctypenew&gt;</tt></h3><div ui-view="doctypenewview"></div>
              <h3 class="alert alert-info"><tt>&lt;doctypelist doctypes="?"&gt;</tt></h3><div ui-view="doctypelistview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdmsvcdoctype entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcdmsdoctype.allcomponents', {
        url: '/allcomponents',
        resolve: {
          doctype: function () {
            return '';
          },
          doctyperef: function () {
            return '';
          },
          somedoctype: function (Doctype) {
            return Doctype.$find('572b31b07c01597e3e150923');
          },
          alldoctypes: function (Doctype) {
            return Doctype.$search({active: true});
          },
          parentsavesearch: function () {
            return function (doctype, doctyperef) {
              console.log('debug: dummy parentsave called for doctypesearch with: ', doctype, doctyperef);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'doctypesearchview@playground.vcdmsdoctype': {
            component: 'doctypesearch',
            bindings: {
              doctype: 'doctype',
              doctyperef: 'doctyperef',
              editinplace: 'eip'
            }
          },
          'doctypesearchview2@playground.vcdmsdoctype': {
            component: 'doctypesearch',
            bindings: {
              doctype: 'doctype',
              doctyperef: 'doctyperef',
              parentsave: 'parentsavesearch'
            }
          },
          'doctypeeditview@playground.vcdmsdoctype': {
            component: 'doctypeeditor',
            bindings: {
              doctype: 'somedoctype'
            }
          },
          'doctypenewview@playground.vcdmsdoctype': {
            component: 'doctypenew',
            bindings: {
            }
          },
          'doctypelistview@playground.vcdmsdoctype': {
            component: 'doctypelist',
            bindings: {
              doctypes: 'alldoctypes'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcdmsdoctype.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());
